export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'Që teknologjia juaj e kamerave të funksionojë me besueshmëri në afat të gjatë',
      lead: 'SSG Care është abonimi ynë i mirëmbajtjes dhe kujdesit. Pas instalimit mund ta mbani sistemin tuaj me një kontratë Care fleksibël – me tarifë mujore dhe afat të rënë dakord individualisht.',
    },
    abo: {
      title: 'Model abonimi me afat fleksibël',
      lead: 'Instalimi faturohet një herë. Kujdesi i vazhdueshëm bëhet me abonim mujor – i anulueshëm ose me afat minimal fiks.',
      items: {
        '0': { title: 'Kujdes mujor', desc: 'Zgjidhni midis anulimit mujor ose një afati fiks (p.sh. 12 ose 24 muaj) me kushtet përkatëse.' },
        '1': { title: 'Fushëveprim individual', desc: 'Jo çdo sistem ka nevojë për gjithçka. Përcaktojmë bashkë cilat shërbime bëjnë pjesë në kontratën Care – të shkallëzueshme dhe të përshtatshme.' },
        '2': { title: 'Pa kosto të fshehura', desc: 'Tarifë mujore transparente. Shërbimet shtesë jashtë kontratës bihen dakord paraprakisht dhe faturohen veçmas.' },
      },
    },
    pricing: {
      eyebrow: 'Paketat',
      title: 'Zgjidhni paketën tuaj Care',
      lead: 'Të gjitha çmimet janë orientuese. Tarifa përfundimtare varet nga madhësia e sistemit, fushëveprimi dhe afati.',
      featured: 'Zgjedhja më e popullarizuar',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'Për sisteme të vogla', price: 'nga 19 €/muaj', features: { '0': 'Kontroll tremujor (në distancë)', '1': 'Menaxhim i përditësimeve të firmuerit', '2': 'Mbështetje aplikacioni me telefon/email', '3': 'Kërkesa me përparësi' } },
        '1': { name: 'Care Professional', subtitle: 'Për sisteme biznesi', price: 'nga 39 €/muaj', features: { '0': 'Kontroll mujor (në distancë)', '1': 'Përditësime firmueri dhe arnime sigurie', '2': 'Menaxhim përdoruesish dhe të drejtash', '3': 'Kontroll i ruajtjes dhe regjistrimit', '4': 'Ndihmë gjatë ndërrimit të telefonit', '5': 'Shërbim në vend sipas marrëveshjes', '6': 'Përpunim me përparësi' } },
        '2': { name: 'Care Enterprise', subtitle: 'Për shumë-lokacione dhe projekte të mëdha', price: 'Individual', features: { '0': 'Kontroll javor (në distancë)', '1': 'Të gjitha shërbimet Professional', '2': 'Person kontakti i dedikuar', '3': 'Këshilla proaktive zgjerimi', '4': 'Takime të rregullta në vend', '5': 'Dokumentim dhe raportim' } },
      },
    },
    services: {
      title: 'Çfarë mund të bëjë SSG Care për ju',
      items: {
        '0': { title: 'Kontrolle të rregullta', desc: 'Kontroll i funksionit të kamerës, regjistrimit dhe lidhjes së rrjetit – në distancë ose në vend sipas paketës.' },
        '1': { title: 'Përditësime firmueri', desc: 'Kontroll dhe ekzekutim i përditësimeve të rëna dakord sipas prodhuesit.' },
        '2': { title: 'Mbështetje aplikacioni dhe qasjeje', desc: 'Ndihmë me problemet e aplikacionit, qasjen dhe ndërrimin e telefonit.' },
        '3': { title: 'Menaxhim përdoruesish dhe të drejtash', desc: 'Menaxhim i të drejtave të qasjes, përdoruesve të rinj dhe ndryshimeve të lejeve.' },
        '4': { title: 'Regjistrimi dhe ruajtja', desc: 'Kontroll i zënies, cilësisë së regjistrimit dhe kopjeve rezervë.' },
        '5': { title: 'Mbështetje në distancë', desc: 'Qasje në distancë për diagnozë dhe konfigurim, nëse është e mundur dhe e dëshiruar.' },
      },
    },
    form: {
      title: 'Oferta juaj personale Care',
      lead: 'Na tregoni çfarë kujdesi keni parasysh. Do t’ju përgjigjemi me një propozim individual me afat dhe tarifë mujore.',
      customerType: 'Lloji i klientit',
      select: 'Ju lutem zgjidhni',
      privat: 'Privat',
      gewerbe: 'Biznes',
      locations: 'Numri i lokacioneve',
      locations1: '1 lokacion',
      locations2: '2–3 lokacione',
      locations3: '4 dhe më shumë',
      cameraCount: 'Numri i përafërt i kamerave',
      cameras1: '1–2 kamera',
      cameras2: '3–6 kamera',
      cameras3: '7–12 kamera',
      cameras4: '13 dhe më shumë',
      systemStatus: 'Statusi i sistemit',
      statusNew: 'Sistem i ri',
      statusExisting: 'Sistem ekzistues',
      statusExtension: 'Zgjerim i planifikuar',
      contractTerm: 'Afati i dëshiruar i kontratës',
      termOpen: 'I hapur / me marrëveshje',
      termMonthly: 'Anulim mujor',
      term12: '12 muaj',
      term24: '24 muaj',
      term36: '36 muaj',
      name: 'Emri *',
      email: 'Email *',
      phone: 'Telefoni',
      company: 'Kompania',
      message: 'Informacion shtesë',
      maxChars: 'Maksimumi 500 karaktere',
      consent: 'Kam lexuar politikën e privatësisë dhe pranoj përpunimin e të dhënave të mia për këtë kërkesë. *',
      success: 'Faleminderit për kërkesën tuaj. Do t’ju përgjigjemi së shpejti me ofertën tuaj individuale Care.',
      submit: 'Dërgo kërkesën Care',
      submitting: 'Duke u dërguar...',
    },
  },
};